export default __webpack_public_path__ + "static/media/bbva.47b93d1d.png";